<div id="splash-index">
    <div class="h-100 d-flex justify-content-center align-items-center">
        <div class="accommodation-container">
          <div class="list-flex">
            <div class="flex-item" style="margin: 0;">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2900.5899051888464!2d11.38170757691087!3d43.364688071117236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132bcd81f0051137%3A0xe5a4241f13068894!2sVilla%20Catignano!5e0!3m2!1sen!2suk!4v1780844854059!5m2!1sen!2suk"
                style="border:0; min-height: 150px; width: 100%; height: 100%;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div class="flex-item" style="margin: 0;">
              <img src="https://www.villacatignano.it/images/galleries/villa/villa-catignano-gal-8.jpg" />
            </div>
          </div>
          <div class="accommodation-info" style="margin: 0; text-align: center">
            <div class="accommodation-title">Villa Catignano</div>
            <div class="accomedation-address">
              Strada Comunale di Catignano<br />
              25, 53019 Castelnuovo Berardenga<br />
              SI<br />
              Italy
            </div>
            <div class="accommodation-links">
              <a href="https://maps.app.goo.gl/utFpDXGY4XiyN5Tq6" target="_blank">
                <i class="fa-solid fa-location-arrow"></i>
              </a>
              <a href="https://www.instagram.com/villa_catignano/?hl=en" target="_blank">
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.villacatignano.it/index.html" target="_blank">
                <i class="fa-solid fa-arrow-pointer"></i>
              </a>
            </div>
          </div>
        </div>
    </div>
</div>
